import RappidContext from './rappid-context'
import * as joint from '@clientio/rappid'

const MOUSEWHEEL_DELTA_THROTTLE = 0.05
export default class MouseWheelController {
  constructor(private context: RappidContext) {}

  activate(): void {
    this.activateMouseWheel()
  }

  activateMouseWheel(): void {
    this.deactivateAssignedMouseWheelEvents()

    this.context.paper.on(
      'cell:mousewheel',
      (_: joint.dia.CellView, evt: joint.dia.Event, x: number, y: number, delta: number) =>
        this.zoom(evt, delta, x, y),
    )

    this.context.paper.on(
      'blank:mousewheel',
      (evt: joint.dia.Event, x: number, y: number, delta: number) => this.zoom(evt, delta, x, y),
    )
  }

  deactivateAssignedMouseWheelEvents(): void {
    this.context.paper.unbind('cell:mousewheel')
    this.context.paper.unbind('blank:mousewheel')
  }

  zoom(evt: joint.dia.Event, deltaZoom: number, x: number, y: number): void {
    evt.preventDefault()
    this.context.paperScroller.zoom(deltaZoom * MOUSEWHEEL_DELTA_THROTTLE, {
      min: 0.05,
      max: 1.5,
      ox: x,
      oy: y,
    })
  }
}
